// formatCurrencyText.js
'use strict';

import i18n from './i18n.js';
import env from '../resource/env.js';
import getDisplayCurrencyCode from '../resource/getDisplayCurrencyCode.js';
const zeroDecimalCurrencies = env.ZERO_DECIMAL_CURRENCIES || '';

/**
 * Format currency text
 * @param {number} {value} - Value to be formatted.
 * @param {string} {currency} - Currency to be displayed.
 * @return {string} - The formatted price text.
 */
const formatCurrencyText = ({ value, currency, option = {} }) => {
  if (!value || !currency) return '';
  if (
    typeof window === 'undefined' ||
    !window.Intl ||
    !window.Intl?.NumberFormat
  )
    return '';

  const displayCurrency = getDisplayCurrencyCode({ currency });
  const zeroDecimalCurrencyList = zeroDecimalCurrencies.split(' ');
  const defaultOption = {
    style: 'currency',
    minimumFractionDigits: zeroDecimalCurrencyList.includes(
      currency?.toUpperCase()
    )
      ? 0
      : 2,
    currency: displayCurrency,
  };

  return new window.Intl.NumberFormat(i18n.language, {
    ...defaultOption,
    ...option,
  }).format(value);
};

export default formatCurrencyText;
